/**
* 模版
**/ 

<template>
    <div style="background-color: #f0f2f5;" class="forgetpassword">
        <el-menu class="el-menu-demo" router :default-active="this.$route.path" mode="horizontal" text-color="#333" active-text-color="#343951">
            
            <img class="logoimg" src="../../assets/img/logo.png" alt="" @click="goto1('/login')">

        </el-menu>
        
        <div style="display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 3%;">
            <div class="content" style="height: 600px;background-color: white;">
                <!-- 主体内容 -->
                <div style="margin: 40px 20px;">
                    <span style="font-size: larger; font-weight: 600;">找回密码</span>

                    <div style=" float:right; font-size: 14px;
                        color: #333;
                        cursor: pointer;">
                        <span>关于我们</span>
                        <el-divider direction="vertical"></el-divider>
                        <span>联系我们</span>
                        <el-divider direction="vertical"></el-divider>
                        <span>隐私保护</span>
                    </div>
                    <el-divider class="divider" ></el-divider>
                </div>

                <!-- 选择找回方式 -->
                <div v-show="index==2" style="display: flex; justify-content: center;">
                  <div style="width: 70%;">
                    <el-steps align-center :active="0" finish-status="finish" style="width: 100%;padding:20px 0">
                      <el-step title="选择找回方式" :status="'process'"></el-step>
                      <el-step title="手机/或邮箱认证" :status="'wait'"></el-step>
                      <el-step title="设置新密码" ></el-step>
                    </el-steps>
                    <h5 style="text-align:center;">为确认是你本人操作，请选择以下任一方式完成身份验证</h5>
                    <el-divider></el-divider>
                    <el-row :gutter="20" style="display: flex; align-items: center;">
                      <el-col :span="6">
                        <el-button type="info" icon="el-icon-mobile-phone" circle  style="float:right"></el-button>
                      </el-col>
                      <el-col :span="12">
                        <p class="txt1">通过手机号码</p>
                        <p class="txt2">通过已绑定的手机号进行验证，推荐使用</p>
                      </el-col>
                      <el-col :span="4">
                        <el-button type="text"  style="float:left"  @click="submitForm('ruleForm1',0)">立即验证</el-button>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20"  style="display: flex; align-items: center;">
                      <el-col :span="6">
                        <el-button type="info" icon="el-icon-message" circle  style="float:right"></el-button>
                      </el-col>
                      <el-col :span="12">
                        <p class="txt1">通过已绑定的邮箱</p>
                        <p class="txt2">通过已绑定的邮箱进行验证</p></el-col>
                      <el-col :span="4">
                        <el-button type="text"  style="float:left" @click="submitForm('ruleForm1',1)">立即验证</el-button>
                      </el-col>
                    </el-row>
                  </div>
                </div>

                <!-- 手机/或邮箱认证 -->
                <div v-show="index==3" >
                      <el-steps align-center :active="1" finish-status="finish" style="width: 100%;padding:20px 0">
                        <el-step title="选择找回方式" ></el-step>
                        <el-step title="手机/或邮箱认证" :status="'process'"></el-step>
                        <el-step title="设置新密码" :status="'wait'"></el-step>
                      </el-steps>
                  <div style="font-size: 14px;padding: 30px 0px 10px 0px;display: flex; justify-content: center;">
                    <div >
                      <el-form :model="ruleForm2.data" :rules="ruleForm2.rules" ref="ruleForm2" label-width="100px"  >
                        <el-form-item :label="this.ruleForm2.data.validateType==0?'手机号码：':'邮箱：'" prop="username">
                          <el-input size="small" v-model="ruleForm2.data.username"></el-input>
                        </el-form-item>
                        <el-form-item label="验证码" prop="captcha">
                            <div style="display: flex;">
                              <el-input style="width:120px" placeholder="验证码" size="small" v-model="ruleForm2.data.captcha" class="input-with-select">
                              </el-input>
                              
                              <el-button size="small" type="info" v-show="ruleForm2.data.show" @click="getCaptcha" style="margin-top: 4px;height:32px;">发送验证码</el-button>
                              <el-button size="small" type="info" v-show="!ruleForm2.data.show"  style="margin-top: 4px;height:32px;">{{ruleForm2.data.count}} s</el-button>
                              
                            </div>
                        </el-form-item>
                    </el-form>
                      
                    </div>
                  </div>
                  <div style="display: flex; justify-content: center;">
                    <el-divider style="width: 70%;"></el-divider>
                  </div>
                  <div style="display: flex;  justify-content: center;">
                    <el-button  @click="submitForm('previous')">上一步</el-button>
                    <el-button type="primary" :disabled="!ruleForm2.data.captcha" @click="submitForm('ruleForm2')">下一步</el-button>
                  </div>
                </div>
                
                <!-- 设置新密码 -->
                <div v-show="index==4">
                      
                    <el-steps align-center :active="2" finish-status="finish" style="width: 100%;padding:20px 0">
                      <el-step title="选择找回方式" ></el-step>
                      <el-step title="手机/或邮箱认证"></el-step>
                      <el-step title="设置新密码" :status="'process'"></el-step>
                    </el-steps>
                  <div style="display: flex; justify-content: center;">
                    <div  >
                      <!-- <h5 style="text-align:center;">重新设置登录密码</h5> -->
                      
                      <el-form :model="ruleForm3.data" :rules="ruleForm3.rules" ref="ruleForm3" label-width="100px"  >
                          <el-form-item label="新密码" prop="password">
                              <el-input show-password v-model="ruleForm3.data.password" size="small" ></el-input>
                          </el-form-item>
                          <el-form-item label="确认密码" prop="confirmPassword">
                              <el-input show-password v-model="ruleForm3.data.confirmPassword" size="small"></el-input>
                          </el-form-item>
                      </el-form>
                    </div>
                  </div>
                  
                    
                  <div style="display: flex;  justify-content: center;">
                      <el-button  @click="submitForm('previous')">上一步</el-button>
                      <el-button type="primary" :disabled="!ruleForm2.data.captcha" @click="submitForm('ruleForm3')">下一步</el-button>
                    </div>
                </div>

                <!-- 修改成功 -->
                <div v-show="index==5" style="display: flex; justify-content: center;">
                    <div >
                      <el-result icon="success" title="密码修改成功" subTitle="您的密码修改成功，请牢记您的新密码">
                        <template slot="extra">
                          <!-- <el-button  @click="submitForm('previous')">返回首页</el-button> -->
                          <el-button type="primary" size="medium" @click="submitForm('gotoLogin')">去登录</el-button>
                        </template>
                      </el-result>
                    </div>
                    
                  </div>
            </div>
        </div>
        
    <FooterItem></FooterItem>


        
    <transition name="fade">
      <jigsaw-captcha
        ref="captcha"
        v-if="captchaVisible"
        :show="captchaVisible"
        :register="registerCaptcha"
        :login="loginCaptcha"
        @close="onCloseCaptcha"
      ></jigsaw-captcha>
    </transition>


    </div>
</template>

<script>
  
// 导入组件
import JigsawCaptcha from '@/components/CaptchaJigsaw'
import FooterItem from '../../components/footer.vue'

import {send, register, verify, reset} from '@/api/userMG'
// 导出模块
export default {
  // 模块名字
  name: "forgetPassword",
  // 模块数据
  data() {
    
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if(value.length<8){
          callback(new Error('密码至少8个字符'))
        }
        if(!(/[a-zA-Z]{1,}/.test(value))){
          callback(new Error('密码有至少1个字母(a, b, c...)'))
        }
        if(!(/\d{1,}/.test(value))){
          callback(new Error('有至少1个数字(1, 2, 3...)'))
        }
        if(!(/[A-Z]{1,}/.test(value)) || !(/[a-z]{1,}/.test(value))){
          callback(new Error('包含大写和小写字符'))
        }
        if (this.ruleForm3.data.confirmPassword !== '') {
          this.$refs.ruleForm3.validateField('confirmPassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm3.data.password) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };
    var validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(`请输入${this.ruleForm2.data.validateType==0?'手机号码':'邮箱'}`));
      } else if (this.ruleForm2.data.validateType==0) {
        if(value.length!=11){
          callback(new Error('请输入11位手机号码'));
        }else if(!/^(13[0-9]|14[0-9]|15[0-9]|16[256]|17[01235678]|18[0-9]|19[0-9])\d{8}$/.test(value)){
          callback(new Error('请输入正确的手机号码'));
        }else{
          callback();
        }
        
      } else if (this.ruleForm2.data.validateType==1) {
        const regEmail = /^([0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2})+/
        if(!regEmail.test(value)){
          callback(new Error('请输入合法邮箱'));
        }else{
          callback();
        }
        
      } else {
        callback();
      }
    };
    //数据  
    return {
        captchaVisible: false,
        index: 2,
        codeimg: '',
        ruleForm0: {
            data: {
                username: '',
                imgCode: '',
                t:0
            },
            rules: {
                username: [
                    { required: true, message: '请输入你需要找回密码的用户名', trigger: 'blur' },
                ],
                // imgCode: [
                //     { required: true, message: '请输入验证码', trigger: 'blur' },
                // ],
            }
        }, 
        ruleForm2: {
            data: {
                username: '',
                captcha: '',
                validateType:0,
                show:true,
                count: 0
            },
            rules: {
              username: [
                    { validator: validateUsername, trigger: 'blur' }
                ],
            }
        },   
        ruleForm3: {
            data: {
                password: '',
                confirmPassword: ''
            },
            rules: {
              password: [
                { validator: validatePass, trigger: 'blur' }
              ],
              confirmPassword: [
                { validator: validatePass2, trigger: 'blur' }
              ],
            }
        },   
    };
  },
  // 注册组件
  components: {
    JigsawCaptcha,
    FooterItem
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    goto1(url) {
      this.$router.push({path: url})
    },
    submitForm(formName, num) {
        let _valid = true
        if('ruleForm0'==formName){
          this.$refs[formName].validate(valid => {
              _valid = valid
          })
          if(_valid){
            this.captchaVisible = true
          }
          // this.index++
        }else if('ruleForm1'==formName){
          this.ruleForm2.data.validateType = num
          this.index++
        }else if('ruleForm2'==formName){
          //提交验证码
          let _valid = true
          this.$refs['ruleForm2'].validate(valid => {
              _valid = valid
          })
          if(!_valid){
            return;
          }
          if(!this.ruleForm2.data.captcha){
            this.$message.warning('请输入验证码')
            return;
          }
          const params ={
              username: this.ruleForm2.data.username,
              captcha: this.ruleForm2.data.captcha,
              validateType: this.ruleForm2.data.validateType,
            }
            verify(params).then(res=>{
                if(res.code==0){
                  this.index++
                }else{
                  this.$message.error(res.message)
                }
            })
        }else if('ruleForm3'==formName){
          
          
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // alert('submit!');
              const params = {
                password: this.ruleForm3.data.password,
                sessionid: this.$cookies.get('X-session-id')
              }
              reset(params).then(res=>{
                if(res.code==0){
                  this.index++
                }else{
                  this.$message.error(res.message)
                }
              })
            } else {
              return false;
            }
          });
        }else if('previous'==formName){
          this.$refs['ruleForm2'].resetFields();
          this.index--
        }else if('gotoLogin'==formName){
          this.$router.push({path: '/login'})
        }
    },
    getcode(){
        this.ruleForm0.data.t = (new Date()).getTime()
        this.codeimg = process.env.GATEWAY_URL+'/api/op/getImgCode?t='+this.ruleForm.t

    },
    getCaptcha() {
      let _valid = true
      this.$refs['ruleForm2'].validate(valid => {
          _valid = valid
      })
      if(_valid){
        this.captchaVisible = true
      }
    },

    /**
     * 注册验证码
     */
    registerCaptcha () {
      return new Promise((resolve, reject) => {
        register().then(resp => {
          resolve(resp)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * 拼图校验与登录
     */
    loginCaptcha (token, sliceX) {
      return new Promise((resolve, reject) => {
          // this.index++
          let form = {
            username: this.ruleForm2.data.username,
            token: token,
            sliceX: sliceX
          }
          send(form,this.ruleForm2.data.validateType).then(resp => {
            resolve(resp)
            if(resp.code==0){
              this.$message.success('发送成功')
              //倒计时
              const TIME_COUNT = 60
              if (!this.timer) {
                this.ruleForm2.data.count = TIME_COUNT
                this.ruleForm2.data.show = false
                this.timer = setInterval(() => {
                  if (this.ruleForm2.data.count > 0 && this.ruleForm2.data.count <= TIME_COUNT) {
                    this.ruleForm2.data.count--
                  } else {
                    this.ruleForm2.data.show = true
                    clearInterval(this.timer)
                    this.timer = null
                  }
                }, 1000)
              }
            }else{
              if(resp.code==1001){
                this.$message.warning(`请勿频繁发送${this.ruleForm2.data.validateTyp==0?'短信':'邮件'}`)
              }
            }
          }, err => {
            reject(err)
          })
        
      })
    },

    /**
     * 关闭弹出验证码
     */
    onCloseCaptcha () {
      this.captchaVisible = false
    }

  },
  // 创建前状态(里面是操作)
  beforeCreate() {},
  // 创建完毕状态(里面是操作)
  created() {},
  // 挂载前状态(里面是操作)
  beforeMount() {},
  // 挂载结束状态(里面是操作)
  mounted() {
  },
  // 更新前状态(里面是操作)
  beforeUpdate() {},
  // 更新完成状态(里面是操作)
  updated() {},
  // 销毁前状态(里面是操作)
  beforeDestroy() {},
  // 销毁完成状态(里面是操作)
  destroyed() {}
};
</script>
// scoped 样式只在本组件使用
<style scoped>
/**
 * 导入css样式组件
 * @import "../assets/css/components/index.css";
 */
 
 @media only screen and (max-width: 500px) {
    .forgetpassword .content{
      width: 100%;
    }
 }
 
@media only screen and (min-width: 500px) {
  .forgetpassword .content{
      width: 70%;
    }
}

 .divider{
    margin: 14px 0 !important;
 }
 .el-menu-demo {
  width: 100%;
  height: 50px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}

.logoimg {
  height: 36px;
  position: absolute;
  top: 7px;
  /* left: 67px; */
  margin-left: 30px;
}

.txt1{
    margin-bottom: 10px;
    color: #333333;
    font-weight: normal;
    font-size: 14px;
}
.txt2{    
  color: #aeaeae;
    font-size: 13px;
}
</style>

<style >
  

.geetest_box_logo,.geetest_feedback{
  display: none !important;
}
  .el-submenu__title i {
    display: none;
  }
  .el-menu-item,
  .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }
  .el-submenu__title:hover {
    font-weight: bold;
  }
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }
  .el-menu--horizontal > .el-menu-item {
    height: 50px;
    line-height: 50px;
  }
  .inputmenu .el-input__inner {
    border-radius: 3px;
  }
  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: 2px solid #fff;
    border-bottom-color: #fff !important;
  }
  .el-button--info {
    color: #FFF;
    background-color: #dedede;
    border-color: #dedede;
    color: black;
}
.el-button--info {
    background-color: #8e9093;
    border-color: #8e9093;
    color: white;
}
.el-button--info:hover {
    background: #a6a9ad;
    border-color: #a6a9ad;
    color: #FFF;
}
  </style>


// WEBPACK FOOTER //
// src/views/login/ForgetPassword.vue